"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9211],{

/***/ 47147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PatientDetailsView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/common/states.json
var states_namespaceObject = JSON.parse('[null,"Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttarakhand","Uttar Pradesh","West Bengal","Ladakh","Jammu & Kashmir","Puducherry","Lakshadweep","Delhi","Chandigarh","Dadra and Nagar Haveli and Daman & Diu","Andaman and Nicobar Islands"]');
;// CONCATENATED MODULE: ./components/customer/category/PatientDetailsView.tsx










var PatientDetailsView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var fetchEvents = function fetchEvents() {
        axios_default().get("/api/backend/customers/fetch/QME-" + uhid + "/events").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (props.updateEvents) {
                props.updateEvents(resp.data);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getPetFormData = function getPetFormData() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    !props.uhid && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "formUhid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "UHID"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-7 text-nowrap align-self-center",
                                                    children: "Qme -"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    value: uhid ? uhid : "",
                                                    onChange: function(e) {
                                                        return setUhid(e.target.value);
                                                    },
                                                    name: "uhid",
                                                    type: "text",
                                                    size: "sm",
                                                    placeholder: "Enter UHID if Available"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            !props.isCustomerView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "formExtUhid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "External UHID"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: extUhid ? extUhid : "",
                                            onChange: function(e) {
                                                return setExtUhid(e.target.value);
                                            },
                                            name: "extUhid",
                                            type: "text",
                                            size: "sm",
                                            placeholder: "Enter External UHID if Available"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    props.uhid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-lg-12 mb-3",
                        children: [
                            "UHID : ",
                            props.uhid
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPhone",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Phone no.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: mobile ? mobile : "",
                                    onChange: function(e) {
                                        return setMobile(e.target.value);
                                    },
                                    name: "mobile",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter Phone Number"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-lg-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "mb-3",
                                controlId: "formName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                        className: "fs-7 text-secondary",
                                        children: [
                                            "Pet Name",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        value: name ? name : "",
                                        onChange: function(e) {
                                            return setName(e.target.value);
                                        },
                                        name: "name",
                                        type: "text",
                                        size: "sm",
                                        placeholder: "Enter Pet Name"
                                    })
                                ]
                            }),
                            options && options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3",
                                children: options.map(function(o) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                        label: o.name,
                                        name: "options",
                                        type: "radio",
                                        checked: name == o,
                                        onChange: function() {
                                            return handleSelectPatient(o);
                                        }
                                    }, o);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formFather",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Owner's name",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["fatherName"] ? formData["fatherName"] : "",
                                    onChange: handleChange,
                                    name: "fatherName",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter Owner's name"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPetAge",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Pet Age"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["age"] ? formData["age"] : "",
                                    onChange: handleChange,
                                    name: "age",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter pet age"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPetGender",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Pet Gender"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["gender"] ? formData["gender"] : "",
                                    onChange: handleChange,
                                    name: "gender",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter pet gender"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formAddress",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["address"] ? formData["address"] : "",
                                    onChange: handleChange,
                                    name: "address",
                                    as: "textarea",
                                    size: "sm",
                                    rows: 2,
                                    placeholder: "Enter Address"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    var getPatientFormData = function getPatientFormData() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    !props.uhid && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "formUhid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "UHID"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "fs-7 text-nowrap align-self-center",
                                                    children: "QMe -"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    value: uhid ? uhid : "",
                                                    onChange: function(e) {
                                                        return setUhid(e.target.value);
                                                    },
                                                    name: "uhid",
                                                    type: "text",
                                                    size: "sm",
                                                    placeholder: "Enter UHID if Available"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            !props.isCustomerView && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "formExtUhid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Hospital/Clinic UHID"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: extUhid ? extUhid : "",
                                            onChange: function(e) {
                                                return setExtUhid(e.target.value);
                                            },
                                            name: "extUhid",
                                            type: "text",
                                            size: "sm",
                                            placeholder: "Enter Hospital/Clinic UHID if Any"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    props.uhid && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-6 col-lg-12 mb-3",
                        children: [
                            "UHID : ",
                            props.uhid
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formPhone",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Phone no.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: mobile ? mobile : "",
                                    onChange: function(e) {
                                        return setMobile(e.target.value);
                                    },
                                    name: "mobile",
                                    type: "text",
                                    size: "sm",
                                    placeholder: "Enter Phone Number"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-lg-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "mb-3",
                                controlId: "formName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                        className: "fs-7 text-secondary",
                                        children: [
                                            "Name",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        value: name ? name : "",
                                        onChange: function(e) {
                                            return setName(e.target.value);
                                        },
                                        name: "name",
                                        type: "text",
                                        size: "sm",
                                        placeholder: "Enter Name"
                                    })
                                ]
                            }),
                            options && options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3",
                                children: options.map(function(o) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                        label: o.name,
                                        name: "options",
                                        type: "radio",
                                        checked: name == o,
                                        onChange: function() {
                                            return handleSelectPatient(o);
                                        }
                                    }, o);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formAge",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Age"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["age"] ? formData["age"] : "",
                                    onChange: handleChange,
                                    name: "age",
                                    type: "tel",
                                    size: "sm",
                                    placeholder: "Enter age in years"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formGender",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Gender"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                    onChange: handleChange,
                                    value: formData["gender"],
                                    name: "gender",
                                    size: "sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Male",
                                            children: "Male"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Female",
                                            children: "Female"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Transgender",
                                            children: "Transgender"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Other",
                                            children: "Other"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    props.category == "IPD" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "formFather",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Father's name:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: formData["fatherName"] ? formData["fatherName"] : "",
                                            onChange: handleChange,
                                            name: "fatherName",
                                            type: "text",
                                            size: "sm",
                                            placeholder: "Enter Father's name"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col col-12 col-lg-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                    className: "mb-3",
                                    controlId: "formMother",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                            className: "fs-7 text-secondary",
                                            children: "Mother's name:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                            value: formData["motherName"] ? formData["motherName"] : "",
                                            onChange: handleChange,
                                            name: "motherName",
                                            type: "text",
                                            size: "sm",
                                            placeholder: "Enter Mother's name"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "formAddress",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["address"] ? formData["address"] : "",
                                    onChange: handleChange,
                                    name: "address",
                                    as: "textarea",
                                    size: "sm",
                                    rows: 5,
                                    placeholder: "Enter Address"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col col-12 col-lg-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                className: "fs-7 text-secondary",
                                children: "State:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                className: "form-select form-select-sm",
                                name: "state",
                                value: formData["state"] ? formData["state"] : "",
                                onChange: handleChange,
                                children: availableStates.map(function(s) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: s,
                                        children: s
                                    }, s);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "my-3",
                                controlId: "formDist",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                        className: "fs-7 text-secondary",
                                        children: "District:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        value: formData["district"] ? formData["district"] : "",
                                        onChange: handleChange,
                                        name: "district",
                                        type: "text",
                                        size: "sm",
                                        placeholder: "Enter District"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    var _$ref = (0,react.useState)({
        gender: "MALE"
    }), formData = _$ref[0], updateFormData = _$ref[1];
    var _$ref1 = (0,react.useState)(null), successMessage = _$ref1[0], setSuccessMessage = _$ref1[1];
    var _$ref2 = (0,react.useState)(null), errorMessage = _$ref2[0], setErrorMessage = _$ref2[1];
    var _$ref3 = (0,react.useState)(), name = _$ref3[0], setName = _$ref3[1];
    var _$ref4 = (0,react.useState)(), options = _$ref4[0], setOptions = _$ref4[1];
    var _$ref5 = (0,react.useState)(), mobile = _$ref5[0], setMobile = _$ref5[1];
    var _$ref6 = (0,react.useState)(null), uhid = _$ref6[0], setUhid = _$ref6[1];
    var _$ref7 = (0,react.useState)(null), extUhid = _$ref7[0], setExtUhid = _$ref7[1];
    var _$ref8 = (0,react.useState)(states_namespaceObject), availableStates = _$ref8[0], setAvailableStates = _$ref8[1];
    var _$ref9 = (0,react.useState)(null), role = _$ref9[0], setRole = _$ref9[1];
    (0,react.useEffect)(function() {
        // Perform localStorage action
        setRole(localStorage.getItem("role"));
    }, []);
    var handleChange = function(e) {
        setSuccessMessage("");
        setErrorMessage("");
        updateFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), // Trimming any whitespace
        (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    (0,react.useEffect)(function() {
        if (uhid != null) {
            fetchEvents();
            axios_default().get("/api/backend/customers/fetch/QME-" + uhid).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                if (resp.data == "") {
                    updateFormData({
                        gender: "MALE"
                    });
                    setName(null);
                    setExtUhid(null);
                    setMobile(null);
                } else {
                    updateFormData(resp.data);
                    setName(resp.data.name);
                    setMobile(resp.data.mobile);
                    setExtUhid(resp.data.extUhid);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        uhid
    ]);
    (0,react.useEffect)(function() {
        if (extUhid != null) {
            axios_default().get("/api/backend/customers/fetch/external/" + extUhid).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                if (resp.data != "") {
                    updateFormData(resp.data);
                    setName(resp.data.name);
                    setMobile(resp.data.mobile);
                    setUhid(resp.data.uhid.split("-")[1]);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        extUhid
    ]);
    (0,react.useEffect)(function() {
        if (mobile != null) {
            axios_default().get("/api/backend/customers/fetch/all/" + mobile).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                if (resp.data == "") {
                    setUhid(null);
                } else if (!uhid) {
                    setOptions(resp.data);
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        mobile
    ]);
    (0,react.useEffect)(function() {
        if (props.uhid != null) {
            setUhid(props.uhid.split("-")[1]);
        }
    }, [
        props.uhid
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            handleDataSubmit: function handleDataSubmit() {
                handleSubmit(null);
            }
        };
    });
    var handleSubmit = function(e) {
        if (e) {
            e.preventDefault();
        }
        if (!(0,utils/* validatePhoneNumber */.Y0)(mobile) || !name) {
            setErrorMessage("* Please provide correct data");
            return;
        } else {
            setErrorMessage(null);
        }
        setSuccessMessage("");
        setErrorMessage("");
        if (uhid == null || uhid == "") {
            axios_default().post("/api/backend/customers/create", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                name: name,
                mobile: mobile,
                extUhid: extUhid
            })).then(function(resp) {
                props.postAction(resp.data.uhid);
            }).catch(function(err) {
                setErrorMessage("* Something went wrong! Please try again in some time.");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        } else {
            axios_default().post("/api/backend/customers/update", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                uhid: "QME-" + uhid,
                name: name,
                mobile: mobile,
                extUhid: extUhid
            })).then(function(resp) {
                props.postAction("QME-" + uhid);
            }).catch(function(err) {
                setErrorMessage("* Something went wrong! Please try again in some time.");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    };
    var handleSelectPatient = function(option) {
        setUhid(option.uhid.split("-")[1]);
        setOptions([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
            children: [
                props.category == "Veterinarian" && getPetFormData(),
                props.category != "Veterinarian" && getPatientFormData(),
                successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-success fs-7 my-4",
                    children: successMessage
                }),
                errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-danger fs-7 my-4",
                    children: errorMessage
                })
            ]
        })
    });
});
PatientDetailsView.displayName = "PatientdataView";


/***/ }),

/***/ 71992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ DiagnosticsVisitView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-vertical-timeline-component/style.min.css
var style_min = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap-typeahead/es/index.js + 64 modules
var es = __webpack_require__(82584);
// EXTERNAL MODULE: ./node_modules/react-simple-wysiwyg/lib/index.es.mjs
var index_es = __webpack_require__(72983);
;// CONCATENATED MODULE: ./components/diagnostics/AddDiagnosticTestView.tsx










var AddDiagnosticTestView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var fetchServices = function fetchServices() {
        axios_default().get("/api/backend/inventory/item/fetch/all/" + props.entityQr + "?type=SERVICE").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            var services = resp.data;
            if (props.category != null) {
                var filter = "";
                switch(props.category){
                    case "RADIOLOGY":
                        filter = "Radiology";
                        break;
                    case "LAB":
                        filter = "Lab";
                        break;
                }
                services = resp.data.filter(function(d) {
                    return d.category == filter;
                });
            } else {
                services = resp.data.filter(function(d) {
                    return d.category == "Radiology" || d.category == "Lab" || d.category == "Medical Services";
                });
            }
            setServices(services);
            if (resp.data && resp.data.length > 0) setRecordType(services[0].name);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var addRecord = function addRecord(uhid, visitId, itemId) {
        if (file) {
            uploadFile().then(function(resp) {
                console.log(resp);
                axios_default().post("/api/backend/customer/records/create/" + uhid + "/" + visitId + "?recordType=" + recordType + "&entityQr=" + props.entityQr + "&source=" + props.source + "&diagnosis=" + diagnosis + "&itemId=" + itemId + "&reportRequired=" + reportRequired, {
                    key: resp
                }).then(function(resp) {
                    console.log(resp.data);
                    if (props.postAction) {
                        props.postAction(visitId);
                    }
                    setDiagnosis("");
                    setFile(null);
                    setSelectedRecordType([]);
                    setReportRequired(false);
                    componentRef.current.value = null;
                }).catch(function(err) {
                    setErrorMessage("Error while creating the record");
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,utils/* handleLogout */.hY)();
                    }
                }).finally(function() {
                    return setLoading(false);
                });
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("Error while uploading the file");
            }).finally(function() {
                return setLoading(false);
            });
        } else {
            axios_default().post("/api/backend/customer/records/create/" + props.uhid + "/" + visitId + "?recordType=" + recordType + "&entityQr=" + props.entityQr + "&source=" + props.source + "&diagnosis=" + diagnosis + "&itemId=" + itemId + "&reportRequired=" + reportRequired, {}).then(function(resp) {
                console.log(resp.data);
                if (props.postAction) {
                    props.postAction(visitId);
                }
                setDiagnosis("");
                setFile(null);
                setSelectedRecordType([]);
                setReportRequired(false);
            }).catch(function(err) {
                setErrorMessage("Error while creating the record");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }
    };
    var getAddNewWidget = function getAddNewWidget() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "card p-2 bg-light",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-lg-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex gap-2 gap-lg-3 justify-content-between my-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Typeahead */.pY, {
                                                clearButton: true,
                                                labelKey: "name",
                                                className: "flex-fill",
                                                selected: selectedRecordType,
                                                onChange: handleSelectRecordType,
                                                options: services,
                                                placeholder: "Filter...",
                                                size: "sm"
                                            }),
                                            allowAddingReport && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                                type: "switch",
                                                id: "custom-switch",
                                                checked: reportRequired,
                                                className: "",
                                                onChange: function(e) {
                                                    return setReportRequired(e.target.checked);
                                                },
                                                label: "Report Required"
                                            }),
                                            props.showSave && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "btn btn-warning text-white btn-sm",
                                                onClick: function(e) {
                                                    return handleAddRecord(e, props.uhid, props.visitId);
                                                },
                                                children: [
                                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "spinner-border",
                                                            role: "status"
                                                        })
                                                    }),
                                                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "fw-bold",
                                                        children: "+ Add"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                reportRequired && allowAddingReport && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                        className: "p-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "my-2 fs-7 text-success",
                                                children: " * Can be added Later"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col col-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "my-2 d-flex gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "align-self-center text-info text-nowrap",
                                                            children: "Report attachment:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            ref: componentRef,
                                                            className: "form-control form-select-sm",
                                                            accept: ".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf",
                                                            onChange: handleChange
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col col-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                    className: "my-2",
                                                    controlId: "diagnosis",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "align-self-center text-info",
                                                            children: "Report Details:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                                            containerProps: {
                                                                style: {
                                                                    resize: "vertical",
                                                                    minHeight: "300px"
                                                                }
                                                            },
                                                            value: diagnosis,
                                                            onChange: function(e) {
                                                                return setDiagnosis(e.target.value);
                                                            },
                                                            placeholder: "Write Notes to be printed on all reports"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "my-2",
                                    children: errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-danger fs-6",
                                        children: [
                                            "*",
                                            errorMessage
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    var _$ref = (0,react.useState)(null), successMessage = _$ref[0], setSuccessMessage = _$ref[1];
    var _$ref1 = (0,react.useState)(false), loading = _$ref1[0], setLoading = _$ref1[1];
    var _$ref2 = (0,react.useState)(null), errorMessage = _$ref2[0], setErrorMessage = _$ref2[1];
    var _$ref3 = (0,react.useState)([]), selectedRecordType = _$ref3[0], setSelectedRecordType = _$ref3[1];
    var _$ref4 = (0,react.useState)(), recordType = _$ref4[0], setRecordType = _$ref4[1];
    var _$ref5 = (0,react.useState)(true), allowAddingReport = _$ref5[0], setAllowAddingReport = _$ref5[1];
    var _$ref6 = (0,react.useState)(true), reportRequired = _$ref6[0], setReportRequired = _$ref6[1];
    var _$ref7 = (0,react.useState)(null), diagnosis = _$ref7[0], setDiagnosis = _$ref7[1];
    var _$ref8 = (0,react.useState)(), file = _$ref8[0], setFile = _$ref8[1];
    var _$ref9 = (0,react.useState)(), services = _$ref9[0], setServices = _$ref9[1];
    var componentRef = (0,react.useRef)(null);
    var handleChange = function(event) {
        setErrorMessage(null);
        if (event.target.files && event.target.files[0]) {
            var selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB");
            } else {
                setFile(selectedFile);
            }
        }
    };
    var handleSelectRecordType = function(value) {
        setSelectedRecordType(value);
        if (value && value.length > 0) {
            setRecordType(value[0].name);
        }
    };
    recordType;
    (0,react.useEffect)(function() {
        if (recordType) {
            var recordCategory = services.filter(function(s) {
                return s.name == recordType;
            })[0].category;
            if (recordCategory == "Radiology" || recordCategory == "Lab") {
                setAllowAddingReport(false);
                setReportRequired(true);
            } else {
                setAllowAddingReport(true);
                setReportRequired(false);
            }
        }
    }, [
        recordType
    ]);
    (0,react.useEffect)(function() {
        if (props.entityQr) {
            fetchServices();
        }
    }, [
        props.entityQr
    ]);
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var key, data, _tmp, url, _$ref, newData, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = props.entityQr + "_" + props.uhid + "_" + props.visitId + "_" + file.name;
                        _tmp = {};
                        return [
                            4,
                            axios_default().post("/api/s3/upload", (_tmp.name = key, _tmp.type = file.type, _tmp))
                        ];
                    case 1:
                        data = _state.sent().data;
                        console.log(data);
                        url = data.url;
                        _tmp1 = {};
                        return [
                            4,
                            axios_default().put(url, file, (_tmp1.headers = {
                                "Content-type": file.type,
                                "Access-Control-Allow-Origin": "*"
                            }, _tmp1))
                        ];
                    case 2:
                        _$ref = _state.sent(), newData = _$ref.data;
                        console.log(newData);
                        return [
                            2,
                            key
                        ];
                }
            });
        });
        return function uploadFile() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useImperativeHandle)(ref, function() {
        return {
            handleAddRecord: function handleAddRecord1(uhid, visitId) {
                handleAddRecord(null, uhid, visitId);
            }
        };
    });
    var handleAddRecord = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e, uhid, visitId) {
            var itemId, visitIdCreated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (e) {
                            e.preventDefault();
                        }
                        setErrorMessage(null);
                        setLoading(true);
                        itemId = services.filter(function(svc) {
                            return svc.name == recordType;
                        })[0].id;
                        if (!(!visitId || visitId == null)) return [
                            3,
                            4
                        ];
                        if (!props.createVisit) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            props.createVisit()
                        ];
                    case 1:
                        visitIdCreated = _state.sent();
                        addRecord(uhid, visitIdCreated, itemId);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setErrorMessage("No visit to Map the record");
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        addRecord(uhid, visitId, itemId);
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddRecord(e, uhid, visitId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getAddNewWidget()
    });
});
AddDiagnosticTestView.displayName = "AddDiagnosticTestView";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 5 modules
var Modal = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(43489);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js + 13 modules
var OverlayTrigger = __webpack_require__(98890);
;// CONCATENATED MODULE: ./components/diagnostics/DiagnosticRecordUpdateView.tsx








var DiagnosticRecordUpdateView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var fetchRecord = function fetchRecord() {
        axios_default().get("/api/backend/customer/records/fetch/id/" + props.id).then(function(resp) {
            setRecord(resp.data);
            if (resp.data) {
                setFile(JSON.parse(resp.data.data).key);
            }
            if (resp.data.description && resp.data.description != "null") {
                setDiagnosis(resp.data.description);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var ref1 = (0,react.useState)(), recordId = ref1[0], setRecordId = ref1[1];
    var ref2 = (0,react.useState)(), record = ref2[0], setRecord = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(null), errorMessage = ref4[0], setErrorMessage = ref4[1];
    var ref5 = (0,react.useState)(), file = ref5[0], setFile = ref5[1];
    var ref6 = (0,react.useState)(null), diagnosis = ref6[0], setDiagnosis = ref6[1];
    var componentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (props.id) {
            fetchRecord();
        }
    }, [
        props.id
    ]);
    (0,react.useEffect)(function() {
        if (props.recordId) {
            setRecordId(props.recordId);
        }
    }, [
        props.recordId
    ]);
    var handleChange = function(event) {
        setErrorMessage(null);
        if (event.target.files && event.target.files[0]) {
            var selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB");
            } else {
                setFile(selectedFile);
            }
        }
    };
    var uploadFile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var key, data, _tmp, url, ref, newData, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = props.recordId + "_" + file.name;
                        _tmp = {};
                        return [
                            4,
                            axios_default().post("/api/s3/upload", (_tmp.name = key, _tmp.type = file.type, _tmp))
                        ];
                    case 1:
                        data = _state.sent().data;
                        console.log(data);
                        url = data.url;
                        _tmp1 = {};
                        return [
                            4,
                            axios_default().put(url, file, (_tmp1.headers = {
                                "Content-type": file.type,
                                "Access-Control-Allow-Origin": "*"
                            }, _tmp1))
                        ];
                    case 2:
                        ref = _state.sent(), newData = ref.data;
                        console.log(newData);
                        return [
                            2,
                            key
                        ];
                }
            });
        });
        return function uploadFile() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdate = function(e) {
        e.preventDefault();
        setErrorMessage(null);
        setLoading(true);
        if (file) {
            uploadFile().then(function(resp) {
                console.log(resp);
                axios_default().post("/api/backend/customer/records/update/record/id/" + recordId, {
                    diagnosis: diagnosis,
                    data: {
                        key: resp
                    }
                }).then(function(resp) {
                    console.log(resp.data);
                    props.postAction();
                }).catch(function(err) {
                    setErrorMessage("Error while creating the record. Please verify the record Id");
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,utils/* handleLogout */.hY)();
                    }
                }).finally(function() {
                    return setLoading(false);
                });
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("Error while uploading the file");
            }).finally(function() {
                return setLoading(false);
            });
        } else {
            axios_default().post("/api/backend/customer/records/update/record/id/" + recordId, {
                diagnosis: diagnosis,
                data: new Object({})
            }).then(function(resp) {
                console.log(resp.data);
                props.postAction();
            }).catch(function(err) {
                setErrorMessage("Error while creating the record. Please verify the record Id");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        !props.recordId && props.status == "PENDING" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                className: "my-2",
                                controlId: "recordId",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: recordId,
                                    onChange: function(e) {
                                        return setRecordId(e.target.value);
                                    },
                                    name: "recordId",
                                    type: "text",
                                    placeholder: "Enter Record Id",
                                    className: "form-control-sm"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-2 d-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "align-self-center text-info",
                                        children: "Report:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "file",
                                        ref: componentRef,
                                        className: "form-control form-select-sm",
                                        accept: ".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf",
                                        onChange: handleChange
                                    })
                                ]
                            })
                        }),
                        record && JSON.parse(record.data).key && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-2 d-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "align-self-center text-info",
                                        children: "View uploaded report :"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        rel: "noreferrer",
                                        href: "/api/s3/download/?file=" + JSON.parse(record.data).key,
                                        className: "text-success font-weight-bold",
                                        children: " ↓"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "my-2",
                                controlId: "diagnosis",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "align-self-center text-info ",
                                        children: "Report Details:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                        containerProps: {
                                            style: {
                                                resize: "vertical",
                                                minHeight: "300px"
                                            }
                                        },
                                        value: diagnosis,
                                        onChange: function(e) {
                                            return setDiagnosis(e.target.value);
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "btn btn-info text-white btn-sm",
                            onClick: function(e) {
                                return handleUpdate(e);
                            },
                            children: [
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "spinner-border",
                                        role: "status"
                                    })
                                }),
                                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Add Report"
                                })
                            ]
                        }),
                        errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-danger fs-6",
                            children: [
                                "*",
                                errorMessage
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
DiagnosticRecordUpdateView.displayName = "DiagnosticRecordUpdateView";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./components/ipd/consentForms/RichEditor.tsx
var RichEditor = __webpack_require__(23080);
;// CONCATENATED MODULE: ./components/diagnostics/UpdateDiagnosticServicesTemplateView.tsx









var UpdateDiagnosticServicesTemplateView = function(props) {
    var fetchParameters = function fetchParameters() {
        axios_default().get("/api/backend/templates/param/fetch/all/" + props.cookieEntityQr + "/" + props.id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setParameters(resp.data.filter(function(p) {
                return p.paramType == "VARIABLE";
            }));
            var notes = resp.data.filter(function(p) {
                return p.paramType == "CONSTANT";
            }).length > 0 ? resp.data.filter(function(p) {
                return p.paramType == "CONSTANT";
            })[0] : null;
            setNotes(notes.description);
            setNotesId(notes.id);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var ref = (0,react.useState)(null), errorMessage = ref[0], setErrorMessage = ref[1];
    var ref1 = (0,react.useState)([]), parameters = ref1[0], setParameters = ref1[1];
    var ref2 = (0,react.useState)(null), notes = ref2[0], setNotes = ref2[1];
    var ref3 = (0,react.useState)(null), notesId = ref3[0], setNotesId = ref3[1];
    var ref4 = (0,react.useState)({}), addParam = ref4[0], setAddParam = ref4[1];
    var handleRemove = function(id) {
        setErrorMessage("");
        axios_default().post("/api/backend/templates/param/remove/" + id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            fetchParameters();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("* Something went wrong! Please try again in sometime.");
        });
    };
    var handleAdd = function() {
        setErrorMessage("");
        axios_default().post("/api/backend/templates/param/create/", {
            entityQr: props.cookieEntityQr,
            name: addParam["name"],
            templateId: props.id,
            units: addParam["units"],
            bioReference: addParam["bioReference"],
            type: "User",
            paramType: "VARIABLE",
            rangeStart: addParam["rangeStart"],
            rangeEnd: addParam["rangeEnd"]
        }).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            fetchParameters();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("* Something went wrong! Please try again in sometime.");
        });
    };
    var handleAddNotes = function() {
        setErrorMessage("");
        var urlPath = notesId ? "update/" + notesId : "create/";
        axios_default().post("/api/backend/templates/param/" + urlPath, {
            entityQr: props.cookieEntityQr,
            name: "Notes",
            templateId: props.id,
            type: "User",
            paramType: "CONSTANT",
            description: notes
        }).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            fetchParameters();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("* Something went wrong! Please try again in sometime.");
        });
    };
    var handleChange = function(e) {
        var bioref = null;
        if (e.target.name == "rangeStart") {
            if (addParam["rangeEnd"]) {
                bioref = e.target.value + " - " + addParam["rangeEnd"];
            } else {
                bioref = ">= " + e.target.value;
            }
        }
        if (e.target.name == "rangeEnd") {
            if (addParam["rangeStart"]) {
                bioref = addParam["rangeStart"] + " - " + e.target.value;
            } else {
                bioref = "<= " + e.target.value;
            }
        }
        if (bioref) {
            var _obj;
            setAddParam((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addParam), (_obj = {}, (0,_define_property/* default */.Z)(_obj, e.target.name, e.target.value), (0,_define_property/* default */.Z)(_obj, "bioReference", bioref), _obj)));
        } else {
            setAddParam((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addParam), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
        }
    };
    (0,react.useEffect)(function() {
        if (props.id) {
            fetchParameters();
        }
    }, [
        props.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "min-vh-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "table",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Parameter Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Units"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Range Start"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Range End"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "bioReference"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Action"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            parameters && parameters.map(function(p) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.units
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.rangeStart
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.rangeEnd
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.bioReference
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.entityQr != "system" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#/",
                                                className: "remove text-decoration-none",
                                                onClick: function() {
                                                    return handleRemove(p.id);
                                                },
                                                children: "X"
                                            })
                                        })
                                    ]
                                }, p.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "name",
                                            value: addParam && addParam["name"],
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "units",
                                            value: addParam && addParam["units"],
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "rangeStart",
                                            value: addParam && addParam["rangeStart"],
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "rangeEnd",
                                            value: addParam && addParam["rangeEnd"],
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "bioReference",
                                            value: addParam && addParam["bioReference"],
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-sm btn-warning text-white",
                                            onClick: function() {
                                                return handleAdd();
                                            },
                                            children: "+ Add"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 5,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                            controlId: "notes",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichEditor/* RichEditor */.E, {
                                                data: notes,
                                                setData: setNotes,
                                                height: 300,
                                                placeholder: "Write Notes to be printed on all reports"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-sm btn-warning text-white",
                                            onClick: function() {
                                                return handleAddNotes();
                                            },
                                            children: notesId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "Update"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "+ Add"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-danger fs-5",
                children: errorMessage
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/diagnostics/lab/LabRecordUpdateView.tsx










var LabRecordUpdateView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var getModalForUpdate = function getModalForUpdate() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showUpdateModal,
            onHide: handleCloseUpdateModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateDiagnosticServicesTemplateView, {
                        cookieEntityQr: record && record.entityQr,
                        id: data && data.templateId,
                        postAction: handleCloseUpdateModal
                    })
                })
            ]
        });
    };
    var fetchRecord = function fetchRecord() {
        axios_default().get("/api/backend/customer/records/fetch/id/" + props.id).then(function(resp) {
            setRecord(resp.data);
            setData(JSON.parse(resp.data.data));
            var templateId = JSON.parse(resp.data.data).templateId;
            var params = JSON.parse(resp.data.data).parameters;
            setComments(JSON.parse(resp.data.data).comments);
            axios_default().get("/api/backend/templates/param/fetch/all/" + resp.data.entityQr + "/" + templateId).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                var paramsAvailable = resp.data.filter(function(p) {
                    return p.paramType == "VARIABLE";
                });
                paramsAvailable.forEach(function(pa) {
                    if (params.filter(function(p) {
                        return p.name == pa.name;
                    }).length <= 0) {
                        params = (0,_to_consumable_array/* default */.Z)(params).concat([
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pa), {
                                result: null
                            })
                        ]);
                    }
                });
                setParameters(params);
                var notes = resp.data.filter(function(p) {
                    return p.paramType == "CONSTANT";
                }).length > 0 ? resp.data.filter(function(p) {
                    return p.paramType == "CONSTANT";
                })[0] : null;
                setNotes(notes.description);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var ref1 = (0,react.useState)(), recordId = ref1[0], setRecordId = ref1[1];
    var ref2 = (0,react.useState)(), record = ref2[0], setRecord = ref2[1];
    var ref3 = (0,react.useState)(), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react.useState)([]), parameters = ref4[0], setParameters = ref4[1];
    var ref5 = (0,react.useState)(), notes = ref5[0], setNotes = ref5[1];
    var ref6 = (0,react.useState)(), comments = ref6[0], setComments = ref6[1];
    var ref7 = (0,react.useState)(false), loading = ref7[0], setLoading = ref7[1];
    var ref8 = (0,react.useState)(null), errorMessage = ref8[0], setErrorMessage = ref8[1];
    var componentRef = (0,react.useRef)(null);
    var ref9 = (0,react.useState)(false), showUpdateModal = ref9[0], setShowUpdateModal = ref9[1];
    var handleCloseUpdateModal = function() {
        return setShowUpdateModal(false);
    };
    var handleShowUpdateModal = function() {
        setShowUpdateModal(true);
    };
    (0,react.useEffect)(function() {
        if (props.id) {
            fetchRecord();
        }
    }, [
        props.id
    ]);
    (0,react.useEffect)(function() {
        if (props.recordId) {
            setRecordId(props.recordId);
        }
    }, [
        props.recordId
    ]);
    var handleUpdate = function(e) {
        e.preventDefault();
        setErrorMessage(null);
        setLoading(true);
        axios_default().post("/api/backend/customer/records/update/record/id/" + recordId, {
            data: {
                category: data.category,
                parameters: parameters,
                notes: notes,
                comments: comments,
                templateId: data.templateId
            }
        }).then(function(resp) {
            console.log(resp.data);
            props.postAction();
        }).catch(function(err) {
            setErrorMessage("Error while creating the record. Please verify the record Id");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        }).finally(function() {
            return setLoading(false);
        });
    };
    var handleChange = function(e, i, value) {
        e.preventDefault();
        setParameters(function(oldParams) {
            oldParams[i] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.parameters[i]), {
                result: value
            });
            return oldParams.map(function(r) {
                return r;
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            data && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    minHeight: "500px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Test Name:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-decoration-underline mb-3 ml-3",
                                children: data.category
                            }),
                            data.templateId && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#/",
                                className: "edit ml-4",
                                onClick: handleShowUpdateModal,
                                children: "✏️ Edit Template"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                className: "table table-borderless",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Result"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Unit"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: "Bio-reference range"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: parameters.map(function(p, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: p.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                            value: parameters[index].result,
                                                            onChange: function(e) {
                                                                return handleChange(e, index, e.target.value);
                                                            },
                                                            name: "result",
                                                            className: "form-control form-control-sm",
                                                            placeholder: "Enter Result"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: p.units
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: p.bioReference
                                                    })
                                                ]
                                            }, "para" + index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Comments:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                containerProps: {
                                    style: {
                                        resize: "vertical",
                                        minHeight: "300px"
                                    }
                                },
                                value: comments,
                                onChange: function(e) {
                                    return setComments(e.target.value);
                                },
                                placeholder: "Add Comments Here"
                            }),
                            notes && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Notes:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: notes
                                        },
                                        className: "border border-dark border-1 pl-2"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "btn btn-info text-white btn",
                        onClick: function(e) {
                            return handleUpdate(e);
                        },
                        children: [
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "spinner-border",
                                    role: "status"
                                })
                            }),
                            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "Save"
                            })
                        ]
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-danger fs-6",
                        children: [
                            "*",
                            errorMessage
                        ]
                    })
                ]
            }),
            getModalForUpdate()
        ]
    });
});
LabRecordUpdateView.displayName = "LabRecordUpdateView";

// EXTERNAL MODULE: ./node_modules/react-to-print/lib/index.js
var lib = __webpack_require__(47116);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./components/diagnostics/lab/LabRecordPrintView.tsx





var LabRecordPrintView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var fetchRecord = function fetchRecord() {
        axios_default().get("/api/backend/customer/records/fetch/id/" + props.id).then(function(resp) {
            resp.data.data = JSON.parse(resp.data.data);
            setRecord(resp.data);
            setCollectionDate(new Date(resp.data.createdAt).toDateString());
            setReportDate(new Date(resp.data.updatedAt).toDateString());
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchEntityDetails = function fetchEntityDetails() {
        axios_default().get("/api/backend/entity/profile/" + props.entityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setEntityDetails(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var outsideRange = function outsideRange(value, rangeStart, rangeEnd) {
        if (!isNaN(rangeStart) && !isNaN(rangeEnd) && !isNaN(value)) {
            return !(Number.parseFloat(value) >= Number.parseFloat(rangeStart) && Number.parseFloat(value) <= Number.parseFloat(rangeEnd));
        } else {
            return false;
        }
    };
    var ref1 = (0,react.useState)(), record = ref1[0], setRecord = ref1[1];
    var ref2 = (0,react.useState)(), entityDetails = ref2[0], setEntityDetails = ref2[1];
    var ref3 = (0,react.useState)(), patientDetails = ref3[0], setPatientDetails = ref3[1];
    var ref4 = (0,react.useState)(), collectionDate = ref4[0], setCollectionDate = ref4[1];
    var ref5 = (0,react.useState)(), reportDate = ref5[0], setReportDate = ref5[1];
    var ref6 = (0,react.useState)("border"), borderClass = ref6[0], setBorderClass = ref6[1];
    var ref7 = (0,react.useState)(40), topMargin = ref7[0], setTopMargin = ref7[1];
    var ref8 = (0,react.useState)(40), bottomMargin = ref8[0], setBottomMargin = ref8[1];
    (0,react.useEffect)(function() {
        if (props.id) {
            fetchRecord();
        }
    }, [
        props.id,
        props.stateTracker
    ]);
    (0,react.useEffect)(function() {
        if (props.printHeader) {
            setBorderClass("");
        }
    }, [
        props.printHeader
    ]);
    (0,react.useEffect)(function() {
        if (props.entityQr) {
            fetchEntityDetails();
            if (props.entityQr == "qme-330") {
                setTopMargin(170);
                setBottomMargin(80);
            }
        }
    }, [
        props.entityQr
    ]);
    (0,react.useEffect)(function() {
        if (props.uhid != null) {
            axios_default().get("/api/backend/customers/fetch/" + props.uhid).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setPatientDetails(resp.data);
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            });
        }
    }, [
        props.uhid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            record && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "dda996bef71c7d8d",
                        [
                            topMargin,
                            bottomMargin
                        ]
                    ]
                ]) + " " + "row printView",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: style_default().dynamic([
                        [
                            "dda996bef71c7d8d",
                            [
                                topMargin,
                                bottomMargin
                            ]
                        ]
                    ]) + " " + "col col-12 my-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: style_default().dynamic([
                            [
                                "dda996bef71c7d8d",
                                [
                                    topMargin,
                                    bottomMargin
                                ]
                            ]
                        ]) + " " + (borderClass || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: style_default().dynamic([
                                [
                                    "dda996bef71c7d8d",
                                    [
                                        topMargin,
                                        bottomMargin
                                    ]
                                ]
                            ]) + " " + "px-5 py-3",
                            children: [
                                props.printHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        props.entityQr != "qme-330" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "dda996bef71c7d8d",
                                                            [
                                                                topMargin,
                                                                bottomMargin
                                                            ]
                                                        ]
                                                    ]) + " " + "font-weight-bold fs-4 text-center",
                                                    children: entityDetails && entityDetails.businessName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "dda996bef71c7d8d",
                                                            [
                                                                topMargin,
                                                                bottomMargin
                                                            ]
                                                        ]
                                                    ]) + " " + "font-weight-bold fs-7 text-center",
                                                    children: entityDetails && entityDetails.businessAddress
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "dda996bef71c7d8d",
                                                    [
                                                        topMargin,
                                                        bottomMargin
                                                    ]
                                                ]
                                            ]) + " " + "card my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: style_default().dynamic([
                                                    [
                                                        "dda996bef71c7d8d",
                                                        [
                                                            topMargin,
                                                            bottomMargin
                                                        ]
                                                    ]
                                                ]) + " " + "row mx-2 my-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "dda996bef71c7d8d",
                                                                [
                                                                    topMargin,
                                                                    bottomMargin
                                                                ]
                                                            ]
                                                        ]) + " " + "col col-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: [
                                                                patientDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                patientDetails.name
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                patientDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Mobile"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "d-inline-block",
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                patientDetails.mobile
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                patientDetails && patientDetails.age && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Age"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                patientDetails.age,
                                                                                "\xa0years"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                patientDetails && patientDetails.gender && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Gender"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                patientDetails.gender
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                patientDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "UHID"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                patientDetails.uhid
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "dda996bef71c7d8d",
                                                                [
                                                                    topMargin,
                                                                    bottomMargin
                                                                ]
                                                            ]
                                                        ]) + " " + "col col-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Sample Date"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                new Date(collectionDate).toLocaleDateString("en-GB")
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                reportDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Report Date"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                new Date(reportDate).toLocaleDateString("en-GB")
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                props.referringDr && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "dda996bef71c7d8d",
                                                                            [
                                                                                topMargin,
                                                                                bottomMargin
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-secondary",
                                                                            children: "Referring Dr"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "dda996bef71c7d8d",
                                                                                    [
                                                                                        topMargin,
                                                                                        bottomMargin
                                                                                    ]
                                                                                ]
                                                                            ]),
                                                                            children: [
                                                                                ":\xa0\xa0",
                                                                                props.referringDr
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "dda996bef71c7d8d",
                                            [
                                                topMargin,
                                                bottomMargin
                                            ]
                                        ]
                                    ]) + " " + "my-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "dda996bef71c7d8d",
                                                    [
                                                        topMargin,
                                                        bottomMargin
                                                    ]
                                                ]
                                            ]) + " " + "text-decoration-underline mb-2",
                                            children: record.data.category
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "dda996bef71c7d8d",
                                                    [
                                                        topMargin,
                                                        bottomMargin
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "dda996bef71c7d8d",
                                                            [
                                                                topMargin,
                                                                bottomMargin
                                                            ]
                                                        ]
                                                    ]) + " " + "table table-borderless",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "dda996bef71c7d8d",
                                                                        [
                                                                            topMargin,
                                                                            bottomMargin
                                                                        ]
                                                                    ]
                                                                ]),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "dda996bef71c7d8d",
                                                                                [
                                                                                    topMargin,
                                                                                    bottomMargin
                                                                                ]
                                                                            ]
                                                                        ]),
                                                                        children: "Name"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "dda996bef71c7d8d",
                                                                                [
                                                                                    topMargin,
                                                                                    bottomMargin
                                                                                ]
                                                                            ]
                                                                        ]),
                                                                        children: "Result"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "dda996bef71c7d8d",
                                                                                [
                                                                                    topMargin,
                                                                                    bottomMargin
                                                                                ]
                                                                            ]
                                                                        ]),
                                                                        children: "Unit"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "dda996bef71c7d8d",
                                                                                [
                                                                                    topMargin,
                                                                                    bottomMargin
                                                                                ]
                                                                            ]
                                                                        ]),
                                                                        children: "Bio-reference range"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: record.data.parameters && record.data.parameters.map(function(p, index) {
                                                                if (p.result) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "dda996bef71c7d8d",
                                                                                [
                                                                                    topMargin,
                                                                                    bottomMargin
                                                                                ]
                                                                            ]
                                                                        ]),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: style_default().dynamic([
                                                                                    [
                                                                                        "dda996bef71c7d8d",
                                                                                        [
                                                                                            topMargin,
                                                                                            bottomMargin
                                                                                        ]
                                                                                    ]
                                                                                ]),
                                                                                children: p.name
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: style_default().dynamic([
                                                                                    [
                                                                                        "dda996bef71c7d8d",
                                                                                        [
                                                                                            topMargin,
                                                                                            bottomMargin
                                                                                        ]
                                                                                    ]
                                                                                ]) + " " + ((outsideRange(p.result, p.rangeStart, p.rangeEnd) ? "fw-bold" : "") || ""),
                                                                                children: p.result
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: style_default().dynamic([
                                                                                    [
                                                                                        "dda996bef71c7d8d",
                                                                                        [
                                                                                            topMargin,
                                                                                            bottomMargin
                                                                                        ]
                                                                                    ]
                                                                                ]),
                                                                                children: p.units
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                                className: style_default().dynamic([
                                                                                    [
                                                                                        "dda996bef71c7d8d",
                                                                                        [
                                                                                            topMargin,
                                                                                            bottomMargin
                                                                                        ]
                                                                                    ]
                                                                                ]),
                                                                                children: p.bioReference
                                                                            })
                                                                        ]
                                                                    }, "para" + index);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }),
                                                record.data.notes && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "dda996bef71c7d8d",
                                                            [
                                                                topMargin,
                                                                bottomMargin
                                                            ]
                                                        ]
                                                    ]) + " " + "my-2 border border-1 border-dark pl-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: "Notes:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: record.data.notes
                                                            },
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]) + " " + "pl-2"
                                                        })
                                                    ]
                                                }),
                                                record.data.comments && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "dda996bef71c7d8d",
                                                            [
                                                                topMargin,
                                                                bottomMargin
                                                            ]
                                                        ]
                                                    ]) + " " + "my-2 border border-1 border-dark pl-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: "Comments:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: record.data.comments
                                                            },
                                                            className: style_default().dynamic([
                                                                [
                                                                    "dda996bef71c7d8d",
                                                                    [
                                                                        topMargin,
                                                                        bottomMargin
                                                                    ]
                                                                ]
                                                            ]) + " " + "pl-2"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                entityDetails && entityDetails.labIncharge && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "dda996bef71c7d8d",
                                            [
                                                topMargin,
                                                bottomMargin
                                            ]
                                        ]
                                    ]) + " " + "mt-5 fw-bold",
                                    children: [
                                        "Lab incharge : ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: style_default().dynamic([
                                                [
                                                    "dda996bef71c7d8d",
                                                    [
                                                        topMargin,
                                                        bottomMargin
                                                    ]
                                                ]
                                            ]) + " " + "fw-normal",
                                            children: entityDetails.labIncharge
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "dda996bef71c7d8d",
                dynamic: [
                    topMargin,
                    bottomMargin
                ],
                children: "@page{margin:".concat(topMargin, "px 0px ").concat(bottomMargin, "px 0px!important}")
            })
        ]
    });
});
LabRecordPrintView.displayName = "LabRecordPrintView";

;// CONCATENATED MODULE: ./components/diagnostics/DiagnosticRecordView.tsx











var DiagnosticRecordView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var getModalForUpdateRecord = function getModalForUpdateRecord() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showUpdateRecordModal,
            onHide: handleCloseUpdateRecordModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                    children: [
                        props.category != "Lab" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosticRecordUpdateView, {
                            id: props.record && props.record.id,
                            recordId: recordToBeUpdated,
                            postAction: handleCloseUpdateRecordModal,
                            status: props.record && props.record.reportStatus
                        }),
                        props.category == "Lab" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LabRecordUpdateView, {
                            id: props.record && props.record.id,
                            recordId: recordToBeUpdated,
                            postAction: handleCloseUpdateRecordModal,
                            status: props.record && props.record.reportStatus
                        })
                    ]
                })
            ]
        });
    };
    var getModalForAlert = function getModalForAlert() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            show: showAlert,
            onHide: handleCloseAlertModal,
            backdrop: "static",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: "text-center my-2 fs-4",
                children: "Report Sent!"
            })
        });
    };
    var componentRef = (0,react.useRef)(null);
    var handleRemove = function() {
        axios_default().get("/api/backend/customer/records/remove/" + props.record.id + "/" + props.record.data.key).then(function(resp) {
            props.fetchRecords();
            console.log(JSON.stringify(resp.data));
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var ref1 = (0,react.useState)(false), showUpdateRecordModal = ref1[0], setShowUpdateRecordModal = ref1[1];
    var ref2 = (0,react.useState)(null), recordToBeUpdated = ref2[0], setRecordToBeUpdated = ref2[1];
    var handleCloseUpdateRecordModal = function() {
        setShowUpdateRecordModal(false);
        props.fetchRecords();
    };
    var handleShowUpdateRecordModal = function(recordToBeUpdated) {
        setRecordToBeUpdated(recordToBeUpdated);
        setShowUpdateRecordModal(true);
    };
    var renderSmsTooltip = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: "sms-tooltip"
        }, props), {
            children: "Send report to Patient"
        }));
    };
    var handleSendDigital = function() {
        axios_default().post("/api/backend/direct/link/create/" + props.record.uhid, {
            entityQr: props.record.entityQr,
            linkType: "TEST",
            linkId: props.record.id
        }).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            handleShowAlertModal();
            setTimeout(function() {
                handleCloseAlertModal();
            }, 2000);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var ref3 = (0,react.useState)(false), showAlert = ref3[0], setShowAlert = ref3[1];
    var handleCloseAlertModal = function() {
        return setShowAlert(false);
    };
    var handleShowAlertModal = function() {
        return setShowAlert(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "diagnostic-record-view-page-icon",
                            height: "14rem",
                            width: "14rem",
                            src: "/external-link.png",
                            className: "align-self-center"
                        }),
                        "\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "text-primary text-decoration-none",
                            onClick: function(e) {
                                return handleShowUpdateRecordModal(props.record.recordId);
                            },
                            children: props.record.recordType
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: props.record.reportStatus == "NOT_REQUIRED" ? "NA" : props.record.reportStatus
                }),
                props.isActive && props.record.reportStatus != "PENDING" && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex gap-2",
                        children: [
                            props.category != "Lab" && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayTrigger/* default */.Z, {
                                placement: "right",
                                delay: {
                                    show: 250,
                                    hide: 400
                                },
                                overlay: renderSmsTooltip,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#/",
                                    onClick: function(e) {
                                        return handleSendDigital();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "diagnostic-record-view-page-icon",
                                        height: "20rem",
                                        width: "20rem",
                                        src: "/sms.png",
                                        className: "align-self-center"
                                    })
                                })
                            }),
                            props.category != "Lab" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: JSON.parse(props.record.data).key && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    rel: "noreferrer",
                                    href: "/api/s3/download/?file=" + JSON.parse(props.record.data).key,
                                    className: "text-success font-weight-bold",
                                    children: " ↓"
                                })
                            }),
                            props.category == "Lab" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                        trigger: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                children: "\uD83D\uDDA8"
                                            });
                                        },
                                        content: function() {
                                            return componentRef.current;
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: componentRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabRecordPrintView, {
                                                uhid: props.uhid,
                                                id: props.record.id,
                                                printHeader: true,
                                                entityQr: props.entityQr,
                                                stateTracker: props.stateTracker,
                                                referringDr: props.referringDr
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                className: "remove",
                                onClick: function(e) {
                                    return handleRemove();
                                },
                                children: "X"
                            })
                        ]
                    })
                }),
                props.isActive && props.record.reportStatus == "PENDING" && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                getModalForUpdateRecord(),
                getModalForAlert()
            ]
        })
    });
});
DiagnosticRecordView.displayName = "DiagnosticRecordView";

// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(53416);
;// CONCATENATED MODULE: ./components/diagnostics/DiagnosticsVisitView.tsx








var DiagnosticsVisitView = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var fetchRecords = function fetchRecords() {
        fetchRecordsUsingVisitId(props.visitId);
        setStateTracker((0,index_browser/* random */.MX)(2));
    };
    var fetchRecordsUsingVisitId = function fetchRecordsUsingVisitId(visitId) {
        axios_default().get("/api/backend/customer/records/fetch/all/" + props.uhid + "/" + visitId).then(function(resp) {
            console.log(JSON.stringify(resp));
            setReferringDr(resp.data.referringDr);
            if (props.diagnosticCategory == "LAB") {
                setLabTests(resp.data.records.filter(function(r) {
                    return r.category == "Lab";
                }));
            } else if (props.diagnosticCategory == "RADIOLOGY") {
                setTests(resp.data.records.filter(function(r) {
                    return r.category == "Radiology";
                }));
            } else {
                setServicesProvided(resp.data.records.filter(function(r) {
                    return r.reportStatus == "NOT_REQUIRED";
                }));
                setTests(resp.data.records.filter(function(r) {
                    return r.reportStatus != "NOT_REQUIRED" && r.category != "Lab";
                }));
                setLabTests(resp.data.records.filter(function(r) {
                    return r.category == "Lab";
                }));
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchServices = function fetchServices() {
        axios_default().get("/api/backend/inventory/item/fetch/all/" + props.entityQr + "?type=SERVICE").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            var services = resp.data.filter(function(d) {
                return d.category == "Medical Services";
            });
            setServices(services);
            if (resp.data && resp.data.length > 0) setRecordType(services[0].name);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getAddedTests = function getAddedTests() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border p-2 mb-3 overflow-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: "table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Medical Service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Report Status"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uD83D\uDCCE"
                                    }),
                                    props.shouldAddNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                                ]
                            })
                        }),
                        tests.map(function(record) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosticRecordView, {
                                record: record,
                                fetchRecords: fetchRecords,
                                isActive: props.shouldAddNew,
                                category: record.category,
                                uhid: props.uhid,
                                entityQr: props.entityQr,
                                stateTracker: stateTracker,
                                referringDr: referringDr
                            }, record.id);
                        })
                    ]
                })
            })
        });
    };
    var getLabTests = function getLabTests() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border p-2 mb-3 overflow-scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    className: "table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Medical Service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Report Status"
                                    }),
                                    props.shouldAddNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                                ]
                            })
                        }),
                        labTests.map(function(record) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosticRecordView, {
                                record: record,
                                fetchRecords: fetchRecords,
                                isActive: props.shouldAddNew,
                                category: "Lab",
                                uhid: props.uhid,
                                entityQr: props.entityQr,
                                stateTracker: stateTracker,
                                referringDr: referringDr
                            }, record.id);
                        })
                    ]
                })
            })
        });
    };
    var getServicesProvided = function getServicesProvided() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: servicesProvided.map(function(r) {
                return r.recordType;
            }).join(", ")
        });
    };
    var ref1 = (0,react.useState)([]), servicesProvided = ref1[0], setServicesProvided = ref1[1];
    var ref2 = (0,react.useState)([]), tests = ref2[0], setTests = ref2[1];
    var ref3 = (0,react.useState)(), referringDr = ref3[0], setReferringDr = ref3[1];
    var ref4 = (0,react.useState)([]), labTests = ref4[0], setLabTests = ref4[1];
    var ref5 = (0,react.useState)(), recordType = ref5[0], setRecordType = ref5[1];
    var ref6 = (0,react.useState)(), services = ref6[0], setServices = ref6[1];
    var ref7 = (0,react.useState)((0,index_browser/* random */.MX)(2)), stateTracker = ref7[0], setStateTracker = ref7[1];
    (0,react.useEffect)(function() {
        if (props.uhid && props.visitId) {
            fetchRecords();
        }
        if (props.entityQr) {
            fetchServices();
        }
    }, [
        props.uhid,
        props.visitId,
        props.shouldAddNew,
        props.entityQr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            props.shouldAddNew && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col col-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddDiagnosticTestView, {
                    visitId: props.visitId,
                    source: props.source,
                    uhid: props.uhid,
                    entityQr: props.entityQr,
                    postAction: fetchRecordsUsingVisitId,
                    showSave: true,
                    category: props.diagnosticCategory,
                    createVisit: props.createVisit
                })
            }),
            servicesProvided && servicesProvided.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 fs-5 text-secondary",
                            children: "Services"
                        }),
                        getServicesProvided()
                    ]
                })
            }),
            tests && tests.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 fs-5 text-secondary",
                            children: "Tests"
                        }),
                        getAddedTests()
                    ]
                })
            }),
            labTests && labTests.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col col-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 d-flex gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " fs-5 text-secondary",
                                children: "Lab Tests"
                            })
                        }),
                        getLabTests()
                    ]
                })
            })
        ]
    });
});
DiagnosticsVisitView.displayName = "DiagnosticsVisitView";


/***/ }),

/***/ 23080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ RichEditor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



var RichEditor = function(props) {
    var editor = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var config = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            readonly: false,
            placeholder: props.placeholder || "Start typing..."
        };
    }, [
        props.placeholder
    ]);
    var JoditEditor = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return __webpack_require__.e(/* import() */ 7661).then(__webpack_require__.t.bind(__webpack_require__, 72911, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(72911)
                ];
            }
        },
        ssr: false
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JoditEditor, {
            ref: editor,
            value: props.data,
            config: config,
            onBlur: function(newContent) {
                return props.setData(newContent);
            },
            onChange: function(newContent) {}
        })
    });
};


/***/ })

}]);